import SectionHeaderTitle from './SectionHeaderTitle';

export default SectionHeaderTitle;
